const IconMoreDefault = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none">
    <path d="M0 20C0 8.95431 8.95431 0 20 0C31.0457 0 40 8.95431 40 20C40 31.0457 31.0457 40 20 40C8.95431 40 0 31.0457 0 20Z" fill="#00CAC0"/>
    <path fillRule="evenodd" clipRule="evenodd" d="M31.6673 21.6663H21.6673V31.6663H18.334V21.6663H8.33398V18.333H18.334V8.33301H21.6673V18.333H31.6673V21.6663Z" fill="#F2F2F2"/>
    </svg>
);

export default IconMoreDefault;
